import React, {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import './staff-booking-warning.css';

export default function StaffBookingWarning({title, message, children, busy, error, onCancel, onConfirm}) {
    const panel = useRef(null), cancel = useRef(onCancel);
    cancel.current = onCancel;
    useEffect(() => {
        const previous = document.activeElement, overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        panel.current?.querySelector('button')?.focus();
        return () => {document.body.style.overflow = overflow; previous?.focus?.();};
    }, []);
    useEffect(() => {
        const escape = e => {if (e.key === 'Escape' && !busy) cancel.current();};
        document.addEventListener('keydown', escape);
        return () => document.removeEventListener('keydown', escape);
    }, [busy]);
    return createPortal(<div className="staff-booking-warning-backdrop" onKeyDown={e => {
        if (e.key !== 'Tab') return;
        const buttons = [...panel.current.querySelectorAll('button:not(:disabled)')];
        if (!buttons.length) {e.preventDefault(); return;}
        if (e.shiftKey && document.activeElement === buttons[0]) {e.preventDefault(); buttons[buttons.length-1].focus();}
        else if (!e.shiftKey && document.activeElement === buttons[buttons.length-1]) {e.preventDefault(); buttons[0].focus();}
    }}><section ref={panel} role="alertdialog" aria-modal="true" aria-labelledby="staff-booking-warning-title" className="staff-booking-warning">
        <h2 id="staff-booking-warning-title">{title}</h2>
        <p>{message}</p>
        <ul>{children}</ul>
        {error && <p role="alert" className="staff-booking-warning-error">{error}</p>}
        <div className="staff-booking-warning-actions">
            <button type="button" data-intent="cancel" disabled={busy} onClick={onCancel}>Cancel</button>
            <button type="button" data-intent="confirm" disabled={busy} onClick={onConfirm}>{busy ? 'Checking…' : 'Override & book'}</button>
        </div>
    </section></div>, document.body);
}
